import { growthPointX } from './growth-geometry';

export const formatGrowthTick = (
  timestamp: string,
  bucketMinutes: number,
  locale?: string,
) =>
  new Intl.DateTimeFormat(locale, {
    timeZone: 'UTC',
    day: 'numeric',
    month: 'short',
    ...(bucketMinutes > 10080 ? { year: 'numeric' as const } : {}),
    ...(bucketMinutes < 1440
      ? {
          hour: '2-digit' as const,
          minute: '2-digit' as const,
          hourCycle: 'h23' as const,
        }
      : {}),
  }).format(new Date(timestamp));

/** Thin axis labels, never data. Try regular, readable intervals before wider ones. */
export const growthAxisTicks = (
  labelWidths: number[],
  bucketMinutes: number,
  plotWidth: number,
): number[] => {
  const count = labelWidths.length;
  if (!count) {
    return [];
  }
  if (count === 1 || plotWidth <= 0) {
    return [0];
  }

  const minimumStep = Math.ceil(count / 7);
  const intervals =
    bucketMinutes < 1440
      ? [60, 120, 180, 300, 360, 720, 1440].map((minutes) =>
          Math.ceil(minutes / bucketMinutes),
        )
      : [1, 2, 3, 5, 7, 10, 14, 30];
  const steps = [...new Set([...intervals, count - 1, count])]
    .filter((step) => step >= minimumStep)
    .sort((a, b) => a - b);
  for (const step of steps) {
    const indices = Array.from(
      { length: Math.ceil(count / step) },
      (_, i) => i * step,
    );
    let previousRight = -Infinity;
    const fits = indices.every((index) => {
      const width = Math.min(plotWidth, labelWidths[index]);
      const left = Math.max(
        0,
        Math.min(
          plotWidth - width,
          growthPointX(index, count, plotWidth) - width / 2,
        ),
      );
      const separated = left >= previousRight + 16;
      previousRight = left + width;
      return separated;
    });
    if (fits) {
      return indices;
    }
  }
  return [0];
};
